import Loadable from "../../react-loadable";
import Plugins from "./plugins";
import Textarea from "./components/Textarea";

// 打开应用连接
const openAppLink = (obj, linkid, linkType) => {
  // 新地址
  if (Number(linkType) === 37) {
    window.openFullWindowHaveBar
      ? window.openFullWindowHaveBar(
          `/spa/document/index.jsp?id=${linkid}&router=1#/main/document/detail`
        )
      : window.open(
          `/spa/document/index.jsp?id=${linkid}&router=1#/main/document/detail`
        );
  } else {
    const discussid = $(obj)
      .parents(".reportItem")
      .attr("id");
    if (linkType == "37")
      window.open(
        "/spa/document/index.jsp?moduleid=blog&id=" +
          linkid +
          "&discussid=" +
          discussid +
          "&linkType=" +
          linkType +
          "&linkid=" +
          linkid
      );
    else if (linkType == "task")
      window.open(
        "/proj/process/ViewTask.jsp?moduleid=blog&taskrecordid=" +
          linkid +
          "&discussid=" +
          discussid +
          "&linkType=" +
          linkType +
          "&linkid=" +
          linkid
      );
    else if (linkType == "18")
      window.open(
        "/spa/crm/static/index.html#/main/crm/customerView?moduleid=blog&customerId=" +
          linkid +
          "&discussid=" +
          discussid +
          "&linkType=" +
          linkType +
          "&linkid=" +
          linkid
      );
    else if (linkType == "152")
      window.open(
        "/spa/workflow/index_form.jsp#/main/workflow/req?moduleid=blog&requestid=" +
          linkid +
          "&discussid=" +
          discussid +
          "&linkType=" +
          linkType +
          "&linkid=" +
          linkid
      );
    else if (linkType == "135")
      window.open(
        "/spa/prj/index.html#/main/prj/projectCard?moduleid=blog&prjid=" +
          linkid +
          "&discussid=" +
          discussid +
          "&linkType=" +
          linkType +
          "&linkid=" +
          linkid
      );
    else if (linkType == "workplan")
      window.open(
        "/spa/workplan/static/index.html#/main/wp/workPlanCreateSingle?moduleid=blog&workid=" +
          linkid +
          "&discussid=" +
          discussid +
          "&linkType=" +
          linkType +
          "&linkid=" +
          linkid
      );
  }
  return false;
};

// 打开附件
function opendoc(obj, showid, versionid, docImagefileid) {
  const discussid = $(obj)
    .parents(".reportItem")
    .attr("id");
  window.openFullWindowHaveBar(
    "/docs/docs/DocDspExt.jsp?id=" +
      showid +
      "&imagefileId=" +
      docImagefileid +
      "&blogDiscussid=" +
      discussid +
      "&isFromAccessory=true&isfromcoworkdoc=1"
  );
}

// 打开附件
function opendoc1(obj, showid) {
  const discussid = $(obj)
    .parents(".reportItem")
    .attr("id");
  window.openFullWindowHaveBar(
    "/docs/docs/DocDsp.jsp?id=" +
      showid +
      "&blogDiscussid=" +
      discussid +
      "&pstate=sub"
  );
}

const WeaRichText = Loadable({
  loader: () => import("./components"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

WeaRichText.openAppLink = openAppLink;
WeaRichText.opendoc = opendoc;
WeaRichText.opendoc1 = opendoc1;
WeaRichText.plugins = Plugins;
WeaRichText.Textarea = Textarea;
export default WeaRichText;



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/index.js